module.exports = __webpack_public_path__ + "7fff4801ce288b3f0bd3f69dc60e1449.svg";